import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsScreensRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-screens',
	path: '/plugins/servlet/project-config/:projectKey/screens',
};
